import React, { useContext, useEffect, useState } from 'react';
import { TextField, Button, Snackbar, Grid, Typography, Modal, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Alert, DatePicker } from '@mui/lab';
import axios from 'axios';
import AppContext from '../context/AppContext';

const AddBeacons = (props) => {
  const storedUserRole = localStorage.getItem('userRole');

    const [input, setInput] = useState({
        category: '',
        assets: '',
        macAddress: props.mac ? props.mac : ''
    });
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    // const [assetData, setAssetData] = useState([]);
    const { asset, setAsset } = useContext(AppContext)
    const { category, location } = useContext(AppContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(()=> {
     const handleResize = ()=> setIsMobile(window.innerWidth <= 768);
     window.addEventListener("resize", handleResize);
     return ()=> window.removeEventListener("resize", handleResize);    
    },[isMobile]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/v1/beacon/link`,
                // `http://localhost:5002/api/v1/beacon/link`,
                { category_name: input.category?.category_name, assets: input.assets, macAddress: input.macAddress }
            );
            if (response.data.status == 'success') {
                setInput({ ...input, category: '', assets: '', macAddress: '' })
                setAsset([...asset])
                setMessage(response.data.message);
                setSeverity('success');
                setOpen(true);
                setOpenModal(false)
            }
        } catch (error) {
            console.log({ error });
            setMessage(error.response?.data?.error || 'Failed to add asset');
            setSeverity('error');
            setOpen(true);
        }
    };



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        console.log({name,value});
        setInput({
            ...input,
            [name]: value,
        });
    };

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handleOpenModal = async () => {
        setOpenModal(true)
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography style={{ display: 'flex', justifyContent: 'flex-end', border: "none", backgroundColor: "transparent", cursor: "pointer", color: storedUserRole == 'demo' ? 'grey' :'green', fontSize: 18 }} onClick={storedUserRole == 'demo' ? ()=> '' : handleOpenModal}> { props?.val ? props.val : "+ Link Beacon" }</Typography>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                >
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",

                            width:isMobile ? 300 : 400,
                            maxHeight: "100%",

                            overflowY: "auto",
                            overflowX: "auto",
                            backgroundColor: "white",
                            boxShadow: 24,
                            padding: "20px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "baseline",
                                justifyContent: "flex-end",
                                cursor: "pointer",
                            }}
                            onClick={handleCloseModal}
                        >
                            <img style={{ width: 20, height: 20 }} src="/Close.png" />
                        </div>
                        <form onSubmit={handleSubmit} style={{ flexDirection: "column", display: "flex" }}>
                            <FormControl style={{ marginTop: '12px' }}>

                                <InputLabel id="asset-select-label" >Category</InputLabel>

                                <Select
                                    labelId="asset-select-label"
                                    id="asset-select"
                                    name='category'
                                    value={input.category?.category_name}
                                    onChange={(e) => handleInputChange(e)}
                                    label="Select category"
                                >
                                    {
                                        props.link ? props.link?.map((asset) => { console.log({asset}); return(
                                            <MenuItem key={asset.id} value={asset}>
                                                {" "}
                                                {asset.category_name}
                                            </MenuItem>
                                        )}) : category?.map((asset) =>{ console.log({asset}); return(
                                            <MenuItem key={asset.id} value={asset}>
                                                {" "}
                                                {asset.category_name}
                                            </MenuItem>
                                        )})
                                    }
                                    {/* {category?.map((asset) => (
                                        <MenuItem key={asset.id} value={asset}>
                                            {" "}
                                            {asset.category_name}
                                        </MenuItem>
                                    ))} */}
                                </Select>

                            </FormControl>

                            <FormControl style={{ marginTop: '12px' }}>

                                <InputLabel id="asset-select-label" >Assets</InputLabel>

                                <Select
                                    labelId="asset-select-label"
                                    id="asset-select"
                                    name='assets'
                                    value={input.assets}
                                    onChange={(e) => handleInputChange(e)}
                                    label="Select Asset"
                                >
                                    {input.category?.totalAsset?.map((asset) => (
                                        <MenuItem key={asset.id} value={asset.asset_name}>
                                            {" "}
                                            {asset.asset_name}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                            <TextField
                                label="Mac Address"
                                name='macAddress'
                                value={input.macAddress}
                                onChange={(e) => handleInputChange(e)}
                                margin="normal"
                                required
                            />
                            <Button type="submit" variant="contained" color="primary" >
                                Add
                            </Button>

                        </form>

                    </div>
                </Modal>
                <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={severity}>
                        {message}
                    </Alert>
                </Snackbar>
            </Grid>

        </Grid>

    );
};

export default AddBeacons;
